"use client";

import { c as _c } from "react-compiler-runtime";
import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";
import { Text } from "@/components/primitives";
import { useTranslation } from "@/core/i18n";
import type { EducationalCard } from "./types";
const ROTATION_INTERVAL_MS = 5_500;
type EducationPanelProps = {
  educationalCards: EducationalCard[];
};
export default function EducationPanel(t0) {
  const $ = _c(34);
  const {
    educationalCards
  } = t0;
  const {
    t
  } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  let t1;
  let t2;
  if ($[0] !== educationalCards.length) {
    t1 = () => {
      if (educationalCards.length <= 1) {
        return;
      }
      const id = setInterval(() => {
        setActiveIndex(prev => (prev + 1) % educationalCards.length);
      }, ROTATION_INTERVAL_MS);
      return () => clearInterval(id);
    };
    t2 = [educationalCards.length];
    $[0] = educationalCards.length;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (educationalCards.length === 0) {
    return null;
  }
  const activeCard = educationalCards[activeIndex];
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 1,
      y: 0
    };
    t4 = {
      opacity: 0,
      y: -12
    };
    t5 = {
      opacity: 0,
      y: 12
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  const t6 = activeCard.id;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      duration: 0.3,
      ease: "easeInOut"
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t) {
    t8 = t("wellnessSteps.processing.didYouKnow");
    $[7] = t;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t8) {
    t9 = <Text component="p" text={t8} tone="muted" variant="overline" weight="bold" />;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== activeCard.titleKey || $[12] !== t) {
    t10 = t(activeCard.titleKey);
    $[11] = activeCard.titleKey;
    $[12] = t;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10) {
    t11 = <div className="mt-1.5"><Text component="p" text={t10} variant="body-sm" weight="semibold" /></div>;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== activeCard.bodyKey || $[17] !== t) {
    t12 = t(activeCard.bodyKey);
    $[16] = activeCard.bodyKey;
    $[17] = t;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12) {
    t13 = <div className="mt-1"><Text component="p" text={t12} variant="caption" /></div>;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t11 || $[22] !== t13 || $[23] !== t9) {
    t14 = <div className="border-smoked-stone/75 bg-card rounded-xl border px-5 py-4 text-left">{t9}{t11}{t13}</div>;
    $[21] = t11;
    $[22] = t13;
    $[23] = t9;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== activeCard.id || $[26] !== t14) {
    t15 = <AnimatePresence mode="wait"><motion.div animate={t3} exit={t4} initial={t5} key={t6} transition={t7}>{t14}</motion.div></AnimatePresence>;
    $[25] = activeCard.id;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== activeIndex || $[29] !== educationalCards) {
    t16 = educationalCards.length > 1 ? <div className="flex items-center justify-center gap-1.5" data-testid="education-carousel-indicator">{educationalCards.map((card, idx) => <span aria-hidden="true" className={`h-1.5 rounded-full transition-all ${idx === activeIndex ? "bg-stone w-4" : "bg-smoked-stone/50 w-1.5"}`} key={card.id} />)}</div> : null;
    $[28] = activeIndex;
    $[29] = educationalCards;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t15 || $[32] !== t16) {
    t17 = <div className="mt-2 w-full space-y-3">{t15}{t16}</div>;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
}